import { z } from 'zod';

/**
 * Client-side login validation only. API / credential errors are set via RHF `setError` after submit.
 * Mirrors the RA2 massager login form (clinic_number + login_id + password).
 */
export const massagerLoginFormSchema = z.object({
  clinic_number: z.string().trim().min(1, '治療院IDは必須です。'),
  login_id: z.string().trim().min(1, '施術者ログインIDは必須です。'),
  password: z.string().trim().min(1, 'パスワードは必須です。'),
});

export type MassagerLoginFormData = z.infer<typeof massagerLoginFormSchema>;
